import request from '../network';

// 使用 any，弱化类型校验
export type StockStatusEnumItem = any;
export type ExchangeProductItem = any;
export type ExchangeProductPageParams = any;

export const getStockStatusEnumApi = () => {
  return request({
    url: '/member/royalcanin/admin/points/exchange/product/stock-status/enum',
    method: 'GET',
  });
};

export const getExchangeProductPageApi = (params: any) => {
  const { shopId, ...rest } = params || {};
  return request({
    url: `/member/royalcanin/admin/points/exchange/product/${shopId}/list/page`,
    method: 'GET',
    params: rest,
  });
};

export const getExchangeProductDetailApi = (shopId: any, id: any) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/product/${shopId}/detail/${id}`,
    method: 'GET',
  });
};

export const addExchangeProductApi = (shopId: any, data: any) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/product/${shopId}/add`,
    method: 'POST',
    data,
  });
};

export const updateExchangeProductApi = (shopId: any, data: any) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/product/${shopId}/update`,
    method: 'POST',
    data,
  });
};

export const deleteExchangeProductApi = (shopId: any, id: any) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/product/${shopId}/delete/${id}`,
    method: 'GET',
  });
};

export const increaseExchangeProductStockApi = (shopId: any, productId: any, quantity: number, remark?: string) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/product/${shopId}/increase-stock/${productId}`,
    method: 'GET',
    params: { quantity, remark },
  });
};

export const reduceExchangeProductStockApi = (shopId: any, productId: any, quantity: number, remark?: string) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/product/${shopId}/reduce-stock/${productId}`,
    method: 'GET',
    params: { quantity, remark },
  });
};
